export default "__VITE_ASSET__d182e586__"